module.exports = __webpack_public_path__ + "img/record-cam.70f722d1.svg";